<div class="d-flex gap-4 align-items-center global-logout">
  <button type="button" class="btn btn-sm btn-danger" (click)="logout()">{{ 'COMMON.LOGOUT' | translate}}</button>
  <div class="color-danger">{{'VIEW.MAIN.SETTINGS.LOGOUT.MESSAGE' | translate}}</div>
</div>